import React from "react"

export default function MsoSnippet({ value }) {
  const escapedValue = "<!--[if mso]>" + value + "<![endif]-->"
  return <mso-snippet dangerouslySetInnerHTML={{ __html: escapedValue }} />
}
